// Admin-only Bestiary view: every species with its Aura, for browsing the art.
// Purely a view switch in this browser tab: nothing is sent to the server, so the
// real Bestiary, milestones and diamonds are untouched. Uses the server's admin
// flag from hello (client/sample.ts), so players never see it.
import { SPECIES, LINES } from '../shared/species.ts';
import { REGIONS } from '../shared/grounds.ts';
import { isSampleAdmin } from './sample.ts';
import { spriteUrl } from './assets.ts';
import { esc } from './fmt.ts';
import { psecTabs, psecWrap } from './psec.ts';

const KEY = 'mi-dex-all';
let on: boolean | null = null;

export function dexAllOn(): boolean {
  if (!isSampleAdmin()) return false;
  if (on === null) { try { on = globalThis.localStorage?.getItem(KEY) === '1'; } catch { on = false; } }
  return on;
}
export function setDexAll(v: boolean) {
  on = v;
  try { globalThis.localStorage?.setItem(KEY, v ? '1' : '0'); } catch { /* storage off */ }
}

/** The switch above the Bestiary (admins only). */
export function dexAllSwitch(): string {
  if (!isSampleAdmin()) return '';
  const all = dexAllOn();
  return `<div class="seg dexall-seg" role="group" aria-label="Bestiary view"><button class="btn small${all ? '' : ' primary'}" data-act="dex-all" data-id="0" aria-pressed="${!all}">My Bestiary</button><button class="btn small${all ? ' primary' : ''}" data-act="dex-all" data-id="1" aria-pressed="${all}">All sprites</button></div>`;
}

const card = (id: string) => {
  const s = SPECIES[id];
  return `<div class="card dexall-card" data-key="da-${id}" data-act="dex-open" data-id="${id}" title="${esc(s.name)}"><div class="dexall-pair"><img src="${spriteUrl(id)}" alt="" loading="lazy"><img src="${spriteUrl(id, true)}" alt="" loading="lazy"></div>
    <div class="nm">${esc(s.name)}</div><div class="lv">${s.rarity}</div></div>`;
};

/** Every species, region by region, then bosses and Awakened forms, one group at a time under tabs. */
export function dexAllPane(): string {
  const listed = new Set<string>();
  const groups = REGIONS.map((r) => {
    const ids = LINES.filter((l) => l.region === r.id).flatMap((l) => l.stages.map((s) => s.id));
    ids.forEach((id) => listed.add(id));
    return { key: r.id as string, title: r.name, ids };
  });
  const rest = Object.keys(SPECIES).filter((id) => !listed.has(id));
  if (rest.length) groups.push({ key: 'rest', title: 'Bosses', ids: rest });
  const keys = groups.map((g) => g.key);
  return `<div class="dex-head"><span class="dex-count">All sprites: <b>${listed.size + rest.length}</b></span>${dexAllSwitch()}</div>
    ${psecTabs('dexall', groups.map((g) => ({ key: g.key, title: `${g.title} ${g.ids.length}` })), undefined, true)}
    ${groups.map((g) => psecWrap('dexall', g.key, keys, `<div class="grid dexall-grid" data-fit="dexall-${g.key}">${g.ids.map(card).join('')}</div>`, true)).join('')}`;
}
